
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special-offers/_sections/Balloons",
      function () {
        return require("private-next-pages/special-offers/_sections/Balloons.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/special-offers/_sections/Balloons"])
      });
    }
  